import React from 'react';
import {render} from 'react-dom';
import App from './components/App';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';


render(<App />, document.getElementById('root'))
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js